import { getSalaryValue } from './salary';

const getFieldsVisibilityConfiguration = (kindId, currentNetwork) => {
  const { fields = {} } =
    currentNetwork?.network_configuration?.business_opportunities?.kind_configurations?.find(
      ({ kind_id: id }) => id === kindId,
    ) || {};

  return fields;
};

export const getLocationValue = (
  location,
  remote,
  defaultValue = '-',
  isAbbriviated = false,
) => {
  const locationValue = isAbbriviated
    ? [location.city, location.country].filter((item) => item).join(', ')
    : location.location || location.address;

  if (locationValue) {
    if (remote) {
      return `${locationValue} · ${__('Remote')}`;
    }

    return locationValue;
  }

  return remote ? __('Remote') : defaultValue;
};

export const constructSubline = (job) => {
  const subline = [];

  if (job.location) {
    const locationValue = getLocationValue(
      job.location,
      job.remote,
      null,
      true,
    );

    subline.push(locationValue);
  } else if (job.remote) {
    subline.push(__('Remote'));
  }
  if (job.kind_name) {
    subline.push(I18n.t(job.kind_name));
  }

  return subline.filter((item) => item).join(' · ');
};

export const prepareDisplayedCustomizableAttributes = (
  customizableAttributes,
) =>
  customizableAttributes.map(
    ({ display_name: label, attribute_type: type, value }) => {
      if (!value && value !== false) {
        return {
          label,
          value: '-',
        };
      }

      let displayValue;
      switch (type) {
        case 'date':
          displayValue = value ? I18n.l('date.formats.long', value) : '-';
          break;
        case 'boolean':
          displayValue = value ? __('Yes') : __('No');
          break;
        case 'double_select':
          displayValue = value.root_value;
          if (value.child_value) {
            displayValue += ` - ${value.child_value.join(', ')}`;
          }
          break;
        default:
          displayValue = Array.isArray(value) ? value.join(', ') : value;
      }

      return {
        label,
        value: displayValue,
      };
    },
  );

export const prepareDisplayedSections = (
  currentNetwork,
  {
    contract_type_name: contractTypeName,
    yearly_salary: yearlySalary,
    monthly_salary: monthlySalary,
    daily_salary: dailySalary,
    currency,
    experience_type_name: experienceTypeName,
    start_date: startDate,
    duration,
    locations = [],
    kind_id: kindId,
    remote,
    customizable_attributes: customizableAttributes,
  } = {},
  includedCustomAttributes = false,
) => {
  const location = locations?.[0] || {};
  const locationValue = getLocationValue(location, remote);

  const visibilityConfiguration = getFieldsVisibilityConfiguration(
    kindId,
    currentNetwork,
  );

  return [
    {
      label: I18n.t('web.shared.location.location'),
      value: locationValue,
      visible: visibilityConfiguration.location,
    },
    {
      label: I18n.t('web.business_opportunities.type_of_contract'),
      value: contractTypeName ? I18n.t(contractTypeName) : '-',
      visible: visibilityConfiguration.contract_type,
    },
    {
      label: I18n.t('web.business_opportunities.offer'),
      value:
        yearlySalary || monthlySalary || dailySalary
          ? getSalaryValue({
              currency: currency?.display,
              yearlySalary,
              monthlySalary,
              dailySalary,
            })
          : '-',
      visible: visibilityConfiguration.monthly_salary,
    },
    {
      label: I18n.t('web.business_opportunities.experience'),
      value: experienceTypeName ? I18n.t(experienceTypeName) : '-',
      visible: visibilityConfiguration.experience_type,
    },
    {
      label: I18n.t('web.business_opportunities.form.start_date'),
      value: startDate ? I18n.l('date.formats.long', startDate) : '-',
      visible: visibilityConfiguration.start_date,
    },
    {
      label: I18n.t('web.business_opportunities.duration'),
      value: duration ?? '-',
      visible: visibilityConfiguration.duration,
    },
    ...(includedCustomAttributes
      ? prepareDisplayedCustomizableAttributes(customizableAttributes)
      : []),
  ]
    .filter(({ visible = true }) => visible)
    .map(({ label, value }) => ({ label, value }));
};
